import styled from 'styled-components'

export const LoginWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 43px;
  padding-top: 27px;
  padding-bottom: 107px;
  margin: 0 auto;
  max-width: 1440px;
  gap: 110px;

  @media only screen and (max-width: 1023px) {
    min-height: 100vh;
    height: auto;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 16px;
  }

  .login-illustration {
    @media only screen and (max-width: 1023px) {
      display: none;
    }
  }
`

export const LoginContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 102.2px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > span {
    &:nth-child(1),
    &:nth-child(2) {
      position: absolute !important;
      width: 10% !important;
    }

    &:nth-child(1) {
      bottom: 10%;
      right: 0;
    }

    &:nth-child(2) {
      top: 10vh;
      left: 45%;
    }
  }

  @media only screen and (max-width: 1023px) {
    min-height: 100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 0.5rem;

    #spacer {
      display: none;
    }

    #formbox-container {
      width: 100%;
      z-index: 2;
    }

    #rect1,
    #rect2 {
      display: none;
    }
  }
`

export const BoxesContainer = styled.div`
  #rect3,
  #rect4 {
    display: none;
  }

  @media only screen and (max-width: 1023px) {
    display: flex;
    justify-content: space-between;
    width: 80%;

    #rect3,
    #rect4 {
      display: inline;
    }
  }
`

export const LanguageSwitcherContainer = styled.div`
  width: 100%;
  max-width: 438px;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 2rem;
  align-self: center;

  @media only screen and (max-width: 1023px) {
    display: flex;
    padding-right: 0;
    margin-bottom: 1rem;
  }
`
